import React, { useEffect } from 'react';

const Hubspot = ({ allowTracking }) => {

  useEffect(() => {
    if (!allowTracking) return;

    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = "text/javascript";
    script.src = "//js.hs-scripts.com/6371311.js";
    script.id = "hs-script-loader";
    script.async = "";
    script.defer = "";
    head.appendChild(script);
  })

  return (
    <></>
  );
};

export default Hubspot;